<script>
  import { RolesRepository } from "../../repositories/index";
  import { onMount, getContext } from "svelte";
  import { _, callout } from "../../stores/index";
  import { ActionFooter, Button, Flex, Icon, Text } from "@gl/design-system";

  import { PoliciesTable } from "../../components/index";
  const { isAuthorized } = getContext("isAuthorized");
  import { navigate } from "../../utils/index";

  export let id;
  export let role;

  let policies;
  let loading = {};
  let policiesTable;

  async function getRolePolicies() {
    try {
      loading.policies = true;

      const result = await RolesRepository.getRolePolicies(id);
      policies = result.list;
    } finally {
      loading.policies = false;
    }
  }

  async function handleSave() {
    loading.submit = true;

    let selected = policiesTable.getSelected();

    let policiesToAdd = selected.filter((s) => !policies.includes(s));

    let policiesToRemove = policies.filter((p) => !selected.includes(p));

    if (policiesToAdd.length === 0 && policiesToRemove.length === 0) {
      callout.set({
        msg: $_("no.changes.callout"),
        status: "warning",
        timeout: true,
      });
      loading.submit = false;
      navigate("/roles");
      return;
    }

    try {
      if (policiesToAdd.length) {
        await RolesRepository.addRolePolicies(id, {
          policies: policiesToAdd,
        });
      }

      if (policiesToRemove.length) {
        await RolesRepository.deleteRolePolicies(id, {
          policies: policiesToRemove,
        });
      }
      callout.set({
        msg: $_("policies.save.callout"),
        status: "success",
        timeout: true,
      });
    } finally {
      loading.submit = false;
      navigate("/roles");
    }
  }

  onMount(() => {
    getRolePolicies();
  });
</script>

<svelte:head>
  <title>
    {$_("layout.role.policies")}: {role.id} |
    {$_("common.roles")} | {$_("access-manager")}
  </title>
</svelte:head>

{#if policies}
  <PoliciesTable subPolicies={policies} bind:this={policiesTable} />
{/if}

{#if $isAuthorized("role_write")}
  <ActionFooter>
    <svelte:fragment slot="left">
      <Button
        on:click={() => {
          getRolePolicies();
          policiesTable.reset();
        }}
        outlined>{$_("common.reset")}</Button
      >
    </svelte:fragment>
    <Button on:click={handleSave} loading={loading.save}
      >{$_("buttons.save")}</Button
    >
    <Button on:click={() => navigate("/roles")} outlined
      >{$_("buttons.cancel")}</Button
    >
  </ActionFooter>
{/if}
